import { DestructiveActionDialog } from './DestructiveActionDialog';

interface MirroredSourceDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (mode: 'both' | 'client-only') => void;
  deleteMode: 'both' | 'client-only';
  onDeleteModeChange: (mode: 'both' | 'client-only') => void;
  clientName?: string;
  partnerName?: string;
}

export function MirroredSourceDeleteDialog({
  open,
  onClose,
  onConfirm,
  deleteMode,
  onDeleteModeChange,
  clientName,
  partnerName,
}: MirroredSourceDeleteDialogProps) {
  const primaryClientName = clientName || 'this client';
  const partnerClientName = partnerName || 'their partner';

  return (
    <DestructiveActionDialog
      open={open}
      onClose={onClose}
      onConfirm={() => onConfirm(deleteMode)}
      title="Delete Mirrored Funding Source"
      description={
        <div>
          <p className="mb-4">
            This self-funding source is mirrored with {partnerClientName}. Please choose how
            you&apos;d like to delete it:
          </p>
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <input
                type="radio"
                id="mirror-delete-both"
                name="mirrorDeleteMode"
                checked={deleteMode === 'both'}
                onChange={() => onDeleteModeChange('both')}
                className="text-primary-600"
              />
              <label
                htmlFor="mirror-delete-both"
                className="text-sm font-medium"
              >
                Delete for both {primaryClientName} and {partnerClientName}
              </label>
            </div>
            <div className="flex items-center gap-2">
              <input
                type="radio"
                id="mirror-delete-client-only"
                name="mirrorDeleteMode"
                checked={deleteMode === 'client-only'}
                onChange={() => onDeleteModeChange('client-only')}
                className="text-primary-600"
              />
              <label
                htmlFor="mirror-delete-client-only"
                className="text-sm font-medium"
              >
                Delete for {primaryClientName} only (unlinks from {partnerClientName})
              </label>
            </div>
          </div>
        </div>
      }
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
    />
  );
}
